import stylex from '@stylexjs/stylex';
import { palette } from '@shared/tokens/palette.stylex';

export const styles = stylex.create({
  container: {
    marginBottom: '8px',
    maxHeight: '320px',
    ':not(#__unused__) > svg': {
      fill: palette['grey-950'],
    },
    ':not(#__unused__) > svg *[fill="#FFF"]': {
      fill: 'transparent',
    },
  },
});
